<template>

    <div>

        <modal
            :title="$t(modalTitle)"
            :width="480"
            cancel-text="Abbrechen"
            transition="fadeDown"
            :show-ok="false"
            :is-show="showModal"
            :on-cancel="exportModalOnCancel"
            :backdrop-closable="false"
            @close="showModal=false"
            class="vcenter">

            <template v-if="currentStatus == null">

                <loading-indicator-small></loading-indicator-small>

            </template>

            <template v-else>

                <template v-if="currentStatus.status != 'Finished'">

                    <div class="has-text-centered" style="margin-bottom: 5px;">{{ currentStatus.log }}</div>
                    <progress-bar :percent="currentStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                </template>

                <template v-else>

                    <div class="has-text-centered">

                        <a :href="downloadLink" download class="button is-success" @click.stop="showModal=false">
                            <span class="icon"><i class="fa fa-download"></i></span>
                            &nbsp;<span>DOWNLOAD PDF</span>
                        </a>

                    </div>

                </template>

            </template>



        </modal>

        <custom-button type="dark" icon="icon-ak-export" :name="btnTitle" v-on:click.native="doExport()"></custom-button>

    </div>

</template>


<script>

export default {

    name: 'exportToPDF',

    props: {
        modalTitle: {
            type: String,
            default: 'EXPORT'
        },
        btnTitle: {
            type: String,
            default: 'EXPORT'
        },
        exportURL: {
            type: String,
            required: true
        }

    },

    data () {

        return {

            showModal: false,
            currentStatus: null,
            refreshIntervalId: null
        }

    },

    created() {


    },

    computed: {

        downloadLink() {
            return this.$config.assets +  this.currentStatus.log;
        }

    },

    watch: {

        showModal(val) {

            if(val == false) {
                clearInterval(this.refreshIntervalId);
            }

        }


    },

    methods: {

        doExport() {

            var self = this;

            this.axios.get(this.$config.api + this.exportURL)
                .then(function(response) {

                    self.showModal = true;

                    let taskLogId = response.data.taskLogId;

                    self.refreshIntervalId = setInterval(function() {

                        self.axios.get(self.$config.api + 'taskLog/' + taskLogId).then(function(response) {

                            self.currentStatus = response.data;

                            if(['Finished', 'Error'].indexOf(response.data.status) > 0) {
                                clearInterval(self.refreshIntervalId);
                            }

                        });

                    }.bind(self), 500);


                });

        },

        exportModalOnCancel() {

            clearInterval(this.refreshIntervalId);

        },

    }

}

</script>

<style lang="scss">

    .modal {

        .modal-card {
            min-height: 100px !important;
        }
    }

</style>
